import { Editor } from 'slate';
import { getBlockAbove } from './get-block-above';
import { isEnd } from './is-end';

export function isBlockEnd(editor: Editor, options?: Parameters<typeof getBlockAbove>[1]) {
    const path = getBlockAbove(editor, options)?.[1];

    return !!path && isEnd(editor, editor.selection?.anchor, path);
}
